"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEY_RENEWAL_BUFFER = exports.KEY_VALIDITY_PERIOD = exports.ALGOLIA_KEY_STORAGE = exports.CACHE_TTL = exports.ApiEndpoints = void 0;
const BASE_URL = "https://analytics.us.algolia.com";
class ApiEndpoints {
}
exports.ApiEndpoints = ApiEndpoints;
ApiEndpoints.POPULAR_SEARCH = BASE_URL + "/2/searches";
exports.CACHE_TTL = 3600 * 6; // 6 hours
exports.ALGOLIA_KEY_STORAGE = "uemd-652l-os85w-v67od";
exports.KEY_VALIDITY_PERIOD = 3600; // 1 hour in seconds
exports.KEY_RENEWAL_BUFFER = 300; // 5 minutes in seconds
